import React from 'react';
import {
  Upload, Sparkles, FileSpreadsheet, MessageCircle, ArrowDown,
} from '../components/Icons';

const SAMPLE_STYLES = [
  { src: '/images/pro-style-handwritten.png', label: 'Handwritten' },
  { src: '/images/pro-style-thermal-pos.png', label: 'Thermal POS receipt' },
  { src: '/images/pro-style-preprinted.png', label: 'Preprinted + handwritten' },
  { src: '/images/pro-style-crumpled.png', label: 'Crumpled or blurry' },
  { src: '/images/pro-style-clean-printed.png', label: 'Clean printed' },
];

const STEPS = [
  {
    icon: Upload,
    title: '1. Upload photos',
    description: 'Snap or upload photos of noisy, crumpled or handwritten invoices. No scanner needed.',
  },
  {
    icon: Sparkles,
    title: '2. We clean it up',
    description: 'AI reads each invoice and extracts item names, quantities, rates and totals into a structured CSV.',
  },
  {
    icon: FileSpreadsheet,
    title: '3. Review and submit',
    description: 'Check the CSV, fix anything that looks off, then upload it straight into your existing FBR batch submission.',
  },
];

// The Invoice Parsing tab of the Pro Features page.
const InvoiceParsingPro = ({ whatsappLink }) => (
  <>
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <h2 className="text-xl font-semibold text-gray-900">Turn a phone photo of a messy invoice into a clean CSV</h2>
      <p className="mt-1 text-gray-600">Ready to review and submit to FBR in a batch.</p>
    </div>

    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-1">We handle every format</h3>
      <p className="text-sm text-gray-500 mb-4">Real photos of the kinds of invoices small businesses actually work with, not scanner quality documents.</p>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        {SAMPLE_STYLES.map((s) => (
          <div key={s.src} className="overflow-hidden rounded-lg border border-gray-200">
            <img src={s.src} alt={s.label} className="aspect-[3/4] w-full object-cover" />
            <div className="bg-gray-50 px-2 py-1.5 text-center text-xs font-medium text-gray-600">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="my-5 flex flex-col items-center justify-center gap-1 text-gray-400">
        <span className="text-xs font-semibold uppercase tracking-wide text-amber-600">Process</span>
        <ArrowDown className="h-6 w-6" />
      </div>

      <div className="overflow-hidden rounded-lg border border-gray-200">
        <img src="/images/pro-style-csv-output.png" alt="Clean spreadsheet output with item, quantity, rate and amount columns" className="w-full object-cover" />
      </div>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {STEPS.map((step) => (
        <div key={step.title} className="bg-white rounded-lg shadow p-5">
          <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-amber-50 text-amber-600">
            <step.icon className="h-5 w-5" />
          </div>
          <div className="mb-1 font-semibold text-gray-900">{step.title}</div>
          <div className="text-sm text-gray-500">{step.description}</div>
        </div>
      ))}
    </div>

    <div className="mt-6 bg-white rounded-lg shadow p-6 flex flex-wrap items-center justify-between gap-4">
      <div>
        <div className="text-sm font-medium text-gray-500">One time unlock</div>
        <div className="text-3xl font-semibold text-gray-900">Rs. 2,000</div>
        <div className="mt-1 text-sm text-gray-500">No subscription. Pay once, use it for every future invoice batch.</div>
      </div>
      <a
        href={whatsappLink('Invoice Parsing Pro feature (Rs. 2,000 one time)')}
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center gap-2 rounded-lg bg-amber-600 px-5 py-3 text-base font-medium text-white hover:bg-amber-700 transition-colors"
      >
        <MessageCircle className="h-5 w-5" /> Request access on WhatsApp
      </a>
    </div>
  </>
);

export default InvoiceParsingPro;
